import React, { useState, useEffect } from 'react';
import API from '../services/api';

const RecentChanges = () => {
  const [changes, setChanges] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchChanges = async () => {
      try {
        setLoading(true);
        const res = await API.get('/admin/system/changes');
        setChanges(res.data?.data || []);
      } catch (e) {
        console.error("Failed to fetch recent changes", e);
      } finally {
        setLoading(false);
      }
    };
    fetchChanges();
  }, []);

  return (
    <div style={{
      background: "hsl(var(--card))",
      padding: "24px",
      borderRadius: "16px",
      border: "1px solid hsl(var(--border))"
    }}>
      <h3 style={{ margin: "0 0 20px 0", fontSize: "16px", fontWeight: "700", color: "hsl(var(--foreground))" }}>Recent Changes</h3>
      
      {loading ? (
        <div style={{ fontSize: "13px", color: "hsl(var(--muted-foreground))" }}>Loading...</div>
      ) : changes.length === 0 ? (
        <div style={{ fontSize: "13px", color: "hsl(var(--muted-foreground))" }}>No recent changes found.</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {changes.map((change, i) => (
            <div key={i} style={{ display: "flex", gap: "12px", alignItems: "center" }}>
              <div style={{
                width: "36px", height: "36px", borderRadius: "8px",
                background: change.bg, color: change.iconColor,
                display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px"
              }}>
                {change.icon}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: "13px", fontWeight: "600", color: "hsl(var(--foreground))" }}>{change.title}</div>
                <div style={{ fontSize: "11px", color: "hsl(var(--muted-foreground))", marginTop: "2px" }}>{change.time}</div>
              </div>
              <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: "hsl(var(--border))" }}></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentChanges;